<template>
    <v-tooltip :text="disabledReason" location="bottom" :disabled="!disabledReason">
        <template v-slot:activator="{ props: tooltipProps }">
            <span v-bind="tooltipProps">
                <simple-button :disabled="disabled" @click="forecastPromotion(promotion)">
                    {{
                        toSentenceCase(
                            isNewForecast
                                ? $t('forecasting.actions.forecastNewPromotion')
                                : $t('forecasting.actions.forecastPromotion')
                        )
                    }}
                </simple-button>
            </span>
        </template>
    </v-tooltip>
</template>

<script setup>
import { computed } from 'vue';
import { get } from 'lodash';
import { to } from 'await-to-js';
import { useStore } from 'vuex';

const props = defineProps({
    promotion: {
        type: Object,
        required: true,
    },
    disabled: {
        type: Boolean,
        required: false,
        default: false,
    },
    disabledReason: {
        type: String,
        required: false,
        default: null,
    },
});

const store = useStore();

const isNewForecast = computed(() => !get(props.promotion, 'lastForecastDate', null));

const forecastPromotion = async promotion => {
    const [err] = await to(
        store.dispatch('forecasting/forecastSinglePromotion', {
            promotion,
            notDirectInstanceUpdate: true,
        })
    );
    if (err) return console.error(err); // TODO: better error handling
};
</script>
